import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-play",
  "use": "icon-play-usage",
  "viewBox": "0 0 45 45",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 45 45\" id=\"icon-play\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M42 22.5C42 33.27 33.27 42 22.5 42S3 33.27 3 22.5 11.73 3 22.5 3 42 11.73 42 22.5Zm3 0C45 34.926 34.926 45 22.5 45S0 34.926 0 22.5 10.074 0 22.5 0 45 10.074 45 22.5Zm-15.816.24a1 1 0 0 0 0-1.48l-8.012-7.27c-.643-.582-1.672-.126-1.672.741V29.27c0 .867 1.03 1.323 1.672.74l8.012-7.268Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol